// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1l0_7","content":"styles_content__75JHW","selectAll":"styles_selectAll__2APrI"};